<div class="video-player {{videoClass}} p-4 desktop:px-0 max-w-container mx-auto">
  <div [id]="resolvedEmbedId" style="width: 100%; position:relative; padding-top: 56.25%;"></div>
</div>
